import { useMemo } from 'react';
import { buildOwnerTypeOptions } from '../utilities/buildOwnerTypeOptions';
import { useSelectCurrentOrder } from '../../../../../../../selectors/order/selectCurrentOrder';
import { eCreateSigningAppointmentFormDataOwnerTypes } from '../../../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';

export const useBuildOwnerTypeOptions = (
  isCorrection: boolean,
  initialOwnerType?: eCreateSigningAppointmentFormDataOwnerTypes
) => {
  const { data: order } = useSelectCurrentOrder();
  return useMemo(
    () => buildOwnerTypeOptions(order.transaction.transaction_category, order.parties, isCorrection, initialOwnerType),
    [order.transaction.transaction_category, order.parties, isCorrection, initialOwnerType]
  );
};
